import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { DatesService } from 'src/app/shared/services/dates.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { HeaderParams } from '../control-resumido/control-resumido.component';

@Component({
  selector: 'app-deposito-efectivo-cabecera',
  templateUrl: './cabecera.component.html',
  styleUrls: ['./cabecera.component.scss']
})
export class CabeceraComponent implements OnInit {

  // Output
  @Output() onSearch: EventEmitter<HeaderParams> = new EventEmitter<HeaderParams>()

  // Form
  formHeader: FormGroup

  // Utils
  private log: any

  constructor(
    private clog: ConsoleService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private datesService: DatesService
  ) {
    this.log = this.clog.log('DEPOSITO-EFECTIVO-CABECERA')
  }

  ngOnInit() {
    this.createForm()
  }

  private createForm() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()
    this.formHeader = this.fb.group({
      fechaDesde: [initDate, [Validators.required]],
      fechaHasta: [currentDate, [Validators.required]],
    });
  }

  buscar() {
    this.formValidatorsService.validateAllFormFields(this.formHeader)
    if (!this.formHeader.valid)
      return

    this.log('onSearch.emit', this.formHeader.value)
    const { fechaDesde, fechaHasta } = this.formHeader.value
    this.onSearch.emit({
      fecha_desde: fechaDesde,
      fecha_hasta: fechaHasta
    })
  }

}
